export default __webpack_public_path__ + "static/connected-device-62fea81c5d21dca2e13753d4b2fd1cf3.webp";